<template>
  <div class="headBox" v-if="carInfoTxt">
    <div class="headImgBox">
      <van-image v-if="headimgurl" fit="cover" :src="headimgurl">
        <template v-slot:error><img :src="headImgSrc"/></template>
      </van-image>
      <img v-else :src="headImgSrc" />
    </div>
    <div class="fhlud infoBox">
      <span class="user">{{ registerUserInfo?.username }} {{ registerUserInfo?.phone }}</span>
      <span class="ellipsis carInfoTxt">{{ carInfoTxt }}</span>
    </div>
    <van-button plain hairline color="#3088c5" type="primary" size="mini" @click="selectCar">切换车辆</van-button>
  </div>
  <div class="fvlr headEptyBox" v-else @click="selectCar">
    <van-button plain hairline color="#3088c5" type="primary" size="mini">+添加爱车</van-button>
    <span>请添加爱车及经销商以查看商品价格及详情</span>
  </div>
</template>

<script>
import { reactive, toRefs, onMounted, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import headImgSrc from '@/assets/images/headImg.png'
import useCurrentCarInfo from '@/hooks/directSales/useCurrentCarInfo'
export default {
  name: 'Head',
  emits: ['change'],
  props: {},
  components: {},
  setup(props, { emit }) {
    let store = useStore()
    const router = useRouter()
    const { carInfoTxt, carInfo } = useCurrentCarInfo()
    const state = reactive({
      headImgSrc
      // carInfo: store.state.currentCarInfo
    })

    const registerUserInfo = computed(() => store.state.registerUserInfo)

    const headimgurl = computed(() => {
      return registerUserInfo.value?.headimgurl && registerUserInfo.value?.headimgurl.replace('http', 'https')
    })
    const selectCar = () => {
      router.push({ path: '/carList', query: { callBack: true, event: '切换车辆' } })
    }

    watch(
      () => carInfo,
      val => {
        // console.log('carInfo-change', val)
        emit('change', val)
      },
      { immediate: true, deep: true }
    )

    return {
      ...toRefs(state),
      headimgurl,
      registerUserInfo,
      carInfoTxt,
      carInfo,
      selectCar
    }
  }
}
</script>

<style lang="scss" scoped>
.headBox {
  margin: 0 20px 10px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #fff;
  border-radius: 8px;
}
.headEptyBox {
  margin: 0 20px 10px;
  padding: 5px;
  background: #fff;
  border-radius: 2px;
}
.headImgBox {
  width: 40px;
  height: 40px;
  overflow: hidden;
  border-radius: 5px;
  background-color: #fff;
  img {
    width: 40px;
    height: 40px;
  }
}
.infoBox {
  width: calc(100% - 130px);
  margin: 10px 20px 10px 10px;
  .user {
    color: #333;
  }
  .carInfoTxt {
    width: 100%;
    display: inline-block;
    text-align: left;
  }
}
</style>
